/* NOLYA · Le diagnostic · assets/nly-diagnostic.js
   · BIBLIOTHÈQUE : les phrases générées du résultat. {sonde} = la technologie de la zone.
   · PARCOURS : quelle question pour quelle zone.
   · L'ORDRE DU RÉSULTAT : resultat(), l'enchaînement des blocs à l'écran.
   · L'E-MAIL : la mise en page de ce que la cliente reçoit.
   · L'ENVOI : ce qui part vers Klaviyo. */
(function(){
'use strict';
var D = JSON.parse(document.getElementById('nly-diag-data').textContent);
var S = D.s;

/* ===================== BIBLIOTHÈQUE ===================== */
var PH = {
  volume_morpho:   'Tu décris du volume localisé, sur une zone qui fait partie de ta silhouette depuis longtemps. On ne la fait pas disparaître : {sonde} la réduit et la redessine.',
  volume_stable:   'Tu décris du volume localisé, présent toute la journée. Ce n’est pas un gonflement, c’est une épaisseur installée : c’est ce que {sonde} vient travailler.',
  volume:          'Tu décris du volume localisé. C’est une épaisseur installée, pas un gonflement : c’est ce que {sonde} vient travailler.',
  variation_avec:  'Mais tu gonfles aussi : le gonflement prend une vraie place dans ce que tu vois.',
  variation_sans:  'Ce que tu décris ressemble surtout à du gonflement : la zone change selon les moments.',
  variation_dig:   ' Tes ballonnements y participent, et ça, NOLYA ne le traite pas. Je préfère te le dire.',
  variation_fin:   ' {sonde} relance la circulation et la zone dégonfle.',
  fermete:         'La peau manque de tenue{depuis}. {sonde} relance le collagène : la peau se retend, progressivement.',
  fermete_seule:   ' On ne cherche pas à réduire, on redonne de la tenue.',
  depuis_perte:    ' depuis ta perte de poids', depuis_gross: ' depuis ta grossesse', depuis_annees: ' avec les années',
  cellulite_3:     'Les capitons sont très marqués', cellulite_2: 'La cellulite est visible debout', cellulite_1: 'La cellulite se voit surtout au pincement',
  cellulite_fine:  ', sur une zone plutôt fine. On ne cherche pas à réduire : on travaille l’aspect de la peau, elle se lisse.',
  cellulite_avec:  '. On lisse la peau en surface, et on déloge le volume en profondeur.',
  cellulite_sans:  '. On la travaille en surface : la peau se lisse, les capitons s’estompent.',
  drainage_jambes: 'Tes jambes deviennent lourdes{quand}. Le drainage esthétique fait partie de ta méthode : elles dégonflent et redeviennent légères.',
  drainage_zone:   'Cette zone a tendance à gonfler. Le drainage esthétique fait partie de ta méthode : elle dégonfle, et le travail tient mieux.',
  quand_souvent:   ' très souvent', quand_moments: ' selon les moments', quand_cycle: ', surtout autour de tes règles',
  vide:            'Le Guide te montre comment observer cette zone la première semaine.',
  joue_grossesse:  'Ton corps a changé après ta grossesse{perte}. C’est souvent là qu’on retrouve du volume sur certaines zones et un manque de fermeté sur d’autres.',
  joue_perte_g:    ' et une perte de poids importante',
  joue_diastasis:  'Un diastasis peut jouer sur le bas-ventre : NOLYA ne le corrige pas, il se travaille à côté, avec un professionnel.',
  joue_cesar:      'Ta cicatrice de césarienne demande d’être contournée : on ne passe jamais la sonde dessus. Le Guide te montre où s’arrêter.',
  joue_perte:      'Tu as perdu beaucoup de poids. La peau ne suit pas toujours, et c’est la fermeté qui reste à retravailler.',
  joue_yoyo:       'Plusieurs prises et pertes de poids laissent souvent deux choses : du volume qui revient au même endroit, et une peau un peu moins ferme.',
  joue_prise:      'Ton corps a changé avec une prise de poids. Ce volume est récent, et c’est plutôt une bonne nouvelle pour le travailler.',
  joue_morpho:     'Ta morphologie semble stocker plus facilement au niveau {de}. On travaille avec, pas contre.',
  joue_menopause:  'Tu as remarqué une évolution autour de la ménopause. On ne réduit pas ton corps à un chiffre sur la balance : on travaille ce que tu vois.',
  joue_contexte:   'Tu m’as parlé {quoi}. Ça peut faire partie du contexte, sans être une explication à tout. NOLYA travaille ce qui relève de la peau et du volume, pas le reste.',
  quoi_endo:       'd’endométriose', quoi_sopk: 'de SOPK', quoi_fibro: 'd’adénomyose ou de fibromes', quoi_thyroide: 'de thyroïde', quoi_et: ' et ',
  joue_contra:     'Un changement de contraception ou une période de stress peuvent avoir déplacé les choses. Ça ne change pas ta méthode.',
  joue_stable:     'Ton poids est plutôt stable. Ce que tu vois n’est pas une question de balance, c’est une question de zones.',
  joue_rien:       'Rien de brutal dans ton histoire. Ce que tu vois s’est installé doucement, et c’est aussi doucement qu’on le travaille.',
  profil_volume:   'Volume installé', profil_cellulite: 'cellulite', profil_fermete: 'relâchement', profil_drainage: 'besoin de drainage', profil_variation: 'gonflement variable',
  profil_morpho:   'Zone de morphologie', profil_vide: 'Profil à affiner',
  ordre_volume:    'volume', ordre_cellulite: 'cellulite', ordre_fermete: 'fermeté', ordre_drainage: 'drainage', ordre_variation: 'drainage', ordre_vide: 'On observe d’abord', ordre_puis: ', puis '
};
/* ===================== FIN DE LA BIBLIOTHÈQUE ===================== */

function abs(u){ if(!u) return null; return u.indexOf('//') === 0 ? 'https:' + u : u; }
function url(v){ if(!v) return null; return abs(typeof v === 'string' ? v : v.src || null); }
var Z = {}, ZORDER = [], PREC = {};
D.zones.forEach(function(z){
  if(!z.id) return; Z[z.id] = z;
  z.img = abs(z.img);
  z.t = (z.techs || '').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  PREC[z.id] = (z.prec || '').split('\n').map(function(x){ return x.trim(); }).filter(Boolean);
  ZORDER.push(z.id);
});
D.intro_image = abs(D.intro_image); D.mach_image = abs(D.mach_image); D.cer_image = abs(D.cer_image);
var Q = {};
D.questions.forEach(function(q){
  if(!q.id) return;
  q.o = (q.options || '').split('\n').map(function(line){
    line = line.trim(); if(!line) return null;
    var parts = line.split('|').map(function(x){ return x.trim(); });
    var o = {l: parts[0], s: {}, h: {}, v: null, x: false, zones: null};
    (parts[1] || '').split(/\s+/).forEach(function(tok){
      if(!tok) return;
      if(tok === 'x'){ o.x = true; return; }
      if(tok.indexOf('h:') === 0){ o.h[tok.slice(2)] = 1; return; }
      if(tok.indexOf('v:') === 0){ o.v = tok.slice(2); return; }
      var kv = tok.split(':'); o.s[kv[0]] = kv[1] ? parseFloat(kv[1]) : 1;
    });
    (parts[2] || '').split(/\s+/).forEach(function(tok){ if(tok.indexOf('zones:') === 0) o.zones = tok.slice(6).split(',').map(function(x){ return x.trim(); }); });
    return o;
  }).filter(Boolean);
  Q[q.id] = q;
});
var T = {
  cav:{n:S.cav_nom, c:S.cav_court, i:url(S.cav_img)},
  rf: {n:S.rf_nom,  c:S.rf_court,  i:url(S.rf_img)},
  vac:{n:S.vac_nom, c:S.vac_court, i:url(S.vac_img)},
  rfv:{n:S.rfv_nom, c:S.rfv_court, i:url(S.rfv_img)}
};
var CHAP = {zones:S.chap_zones, histoire:S.chap_histoire, verif:S.chap_verif};

var st, flow = [];
function reset(){ st = {ecran:'intro', prenom:'', zones:[], prio:null, ans:{}, idx:0}; }
reset();
function key(e){ return e.id + '@' + (e.z || '-'); }
function get(id, z){ return st.ans[id + '@' + (z || '-')]; }
function listeOf(e){ return e.id === 'precision' ? (PREC[e.z] || []).map(function(l){ return {l:l, s:{}, h:{}, v:null, x:false, zones:null}; }) : (Q[e.id] ? Q[e.id].o : []); }
function opts(id, z){ var a = get(id, z) || []; return a.map(function(i){ return Q[id] && Q[id].o[i]; }); }
function has(id, z, sig){ return opts(id, z).some(function(o){ return o && o.s && o.s[sig]; }); }
function precisionsOf(z){ var a = get('precision', z) || []; return a.map(function(i){ return (PREC[z] || [])[i]; }).filter(Boolean); }
function precAffichees(z){ return precisionsOf(z).filter(function(l){ return !/^tout\b/i.test(l); }); }
function ordreZones(){ if(!st.prio) return st.zones.slice(); return [st.prio].concat(st.zones.filter(function(z){ return z !== st.prio; })); }
function prioZone(){ return st.prio || st.zones[0]; }
function grp(z){ return z && Z[z] ? Z[z].groupe : ''; }
function estVisage(z){ return grp(z) === 'menton' || grp(z) === 'visage'; }
function grossesse(){ return verifs().indexOf('grossesse') >= 0; }
/* Le ventre est-il travaillé ? Diastasis et césarienne ne se disent que dans ce cas. */
function ventreTravaille(){ return st.zones.some(function(z){ return grp(z) === 'ventre'; }); }

/* ===================== PARCOURS ===================== */
function buildFlow(){
  var f = [{id:'zones'}];
  if(st.zones.length > 1) f.push({id:'priorite'});
  ordreZones().forEach(function(z, i){
    var P = (i === 0), g = grp(z);
    var voit = {ventre:'voit_ventre', dos:'voit_dos', jambes:'voit_jambes', fesses:'voit_jambes', bras:'voit_bras', menton:'voit_menton', visage:'voit_visage'}[g] || 'voit_corps';
    f.push({id:voit, z:z});
    if((PREC[z] || []).length) f.push({id:'precision', z:z});
    var cel = has(voit, z, 'cellulite');
    if(g === 'ventre'){ f.push({id:'stable_ventre', z:z}); if(P){ f.push({id:'touche', z:z}); f.push({id:'basventre', z:z}); } }
    else if(g === 'jambes'){ f.push({id:'jambes_lourdes', z:z}); if(has('jambes_lourdes', z, 'drainage')) f.push({id:'jambes_legeres', z:z}); if(P) f.push({id:'touche', z:z}); if(cel){ if(P) f.push({id:'cel_volume', z:z}); f.push({id:'cel_visible', z:z}); } }
    else if(g === 'fesses'){ if(P) f.push({id:'touche', z:z}); if(cel){ if(P) f.push({id:'cel_volume', z:z}); f.push({id:'cel_visible', z:z}); if(P) f.push({id:'cel_gonfle', z:z}); } }
    else if(g === 'bras'){ if(P) f.push({id:'touche', z:z}); }
    else if(g === 'dos'){ f.push({id:'dos_poids', z:z}); if(P) f.push({id:'touche', z:z}); }
    else if(g === 'menton' || g === 'visage'){ f.push({id:'menton_poids', z:z}); }
    else { f.push({id:'stable_taille', z:z}); if(P) f.push({id:'touche', z:z}); }
  });
  var p = prioZone(), gp = grp(p);
  if(p){
    f.push({id:'poids', z:p});
    if(gp !== 'dos' && !estVisage(p)) f.push({id:'zone_poids', z:p});
    f.push({id:'moment', z:p}); f.push({id:'contexte', z:p});
    var H = hist(f);
    if(H.grossesse && ventreTravaille()){ f.push({id:'gro_diastasis', z:p}); if(!H.cesar_ctx) f.push({id:'gro_cesar', z:p}); }
    f.push({id:'securite'});
  }
  flow = f.filter(function(e){ return Q[e.id]; });
}
/* ===================== FIN DU PARCOURS ===================== */

function hist(liste){
  var L = liste || flow, vivantes = {}, H = {};
  L.forEach(function(e){ vivantes[e.id + '@' + (e.z || '-')] = 1; });
  Object.keys(st.ans).forEach(function(k){
    if(!vivantes[k]) return;
    var id = k.split('@')[0], d = Q[id]; if(!d || id === 'precision') return;
    st.ans[k].forEach(function(i){ var o = d.o[i]; if(o) Object.keys(o.h).forEach(function(s){ H[s] = (H[s] || 0) + 1; }); });
  });
  var ctx = opts('contexte', prioZone());
  H.diastasis_ctx = ctx.some(function(o){ return o && o.h.diastasis; });
  H.cesar_ctx = ctx.some(function(o){ return o && o.h.cesarienne; });
  return H;
}
function verifs(){ return opts('securite').filter(function(o){ return o && o.v; }).map(function(o){ return o.v; }); }
function sig(z){
  var s = {};
  flow.forEach(function(e){
    if(e.z !== z || e.id === 'precision') return;
    var a = get(e.id, e.z); if(!a) return;
    a.forEach(function(i){ var o = Q[e.id].o[i]; if(o) Object.keys(o.s).forEach(function(k){ s[k] = (s[k] || 0) + o.s[k]; }); });
  });
  return s;
}
/* Quatre besoins retenus par zone. Le drainage et le gonflement comptent dès une demi-réponse :
   un « parfois » suffit à sortir le Vacuum RF. */
function profil(z){
  var s = sig(z), c = [];
  var v = s.volume || 0, f = s.fermete || 0, ce = s.cellulite || 0, d = s.drainage || 0, va = s.variation || 0;
  if(v >= 1 && !s.finesse) c.push({k:'volume', w:v + (s.stable || 0) + (s.morpho || 0) * .5});
  if(ce >= 1) c.push({k:'cellulite', w:ce});
  if(f >= 1) c.push({k:'fermete', w:f});
  if(d >= .5) c.push({k:'drainage', w:d});
  if(va >= .5) c.push({k:'variation', w:va + (s.digestif || 0) * .5});
  c.sort(function(a, b){ return b.w - a.w; });
  return {s:s, c:c.slice(0, 4), morpho:(s.morpho || 0) >= 1};
}
function cle(k){ return {volume:'cav', cellulite:'vac', drainage:'vac', variation:'vac', fermete:'rf'}[k] || null; }
function techPour(z, k){
  var al = (Z[z] && Z[z].t) || [], t = cle(k); if(!t) return null;
  if(estVisage(z)) t = 'rfv';
  if(al.indexOf(t) < 0) t = (k === 'volume' && al.indexOf('vac') >= 0) ? 'vac' : null;
  return t;
}
function techs(z, p){
  var al = (Z[z] && Z[z].t) || [], out = [];
  p.c.forEach(function(x){ var t = techPour(z, x.k); if(t && out.indexOf(t) < 0) out.push(t); });
  if(out.length && !estVisage(z) && al.indexOf('vac') >= 0 && out.indexOf('vac') < 0) out.push('vac');
  return out;
}
function sondeDe(z, k){
  var t = techPour(z, k); if(!t) return 'ta méthode';
  var n = String(T[t].n || '');
  /* 30/09 : « le » vacuum, « la » radiofréquence, « la » lipocavitation. */
  return /^[aeiouyéè]/i.test(n) ? 'l’' + n.charAt(0).toLowerCase() + n.slice(1) : (/^vacuum/i.test(n) ? 'le ' : 'la ') + n.charAt(0).toLowerCase() + n.slice(1);
}
function cap(t){ return String(t || '').charAt(0).toUpperCase() + String(t || '').slice(1); }
/* Les Queues de Cerise n'apparaissent que si elle a vraiment décrit du gonflement ou de la lourdeur. */
function besoinDrainage(){
  return ordreZones().some(function(z){ var s = sig(z); return (s.drainage || 0) >= .5 || (s.variation || 0) >= .5; });
}
/* La réponse donnée à « Tes jambes deviennent-elles lourdes ? » : 0 jamais, 1 parfois, 2 très souvent. */
function lourdeur(z){ return opts('jambes_lourdes', z).reduce(function(m, o){ return Math.max(m, (o && o.s && o.s.drainage) || 0); }, 0); }
function fill(t, m){ return String(t || '').replace(/\{(\w+)\}/g, function(_, k){ return m[k] == null ? '' : m[k]; }); }
function explique(z, p){
  var s = p.s, H = hist(), out = [], hasVol = p.c.some(function(x){ return x.k === 'volume'; });
  p.c.forEach(function(x){
    if(x.k === 'volume'){
      /* La morphologie ne se dit jamais sur le visage ni le double menton. */
      var b = (p.morpho && !estVisage(z)) ? PH.volume_morpho : s.stable ? PH.volume_stable : PH.volume;
      out.push(fill(b, {sonde: sondeDe(z, 'volume')}));
    }
    if(x.k === 'variation'){
      var fin = (grp(z) === 'ventre' && (H.digestif || s.digestif)) ? PH.variation_dig : fill(PH.variation_fin, {sonde: cap(sondeDe(z, 'variation'))});
      out.push((hasVol ? PH.variation_avec : PH.variation_sans) + fin);
    }
    if(x.k === 'fermete'){
      var dep = H.perte ? PH.depuis_perte : H.grossesse ? PH.depuis_gross : (H.menopause || H.annees || s.annees) ? PH.depuis_annees : '';
      out.push(fill(PH.fermete, {depuis:dep, sonde: cap(sondeDe(z, 'fermete'))}) + (hasVol ? '' : PH.fermete_seule));
    }
    if(x.k === 'cellulite'){
      var c = (s.cellulite || 0) >= 4 ? PH.cellulite_3 : (s.cellulite || 0) >= 3 ? PH.cellulite_2 : PH.cellulite_1;
      out.push(c + (s.finesse ? PH.cellulite_fine : hasVol ? PH.cellulite_avec : PH.cellulite_sans));
    }
    if(x.k === 'drainage'){
      /* 18/10 : « très souvent » seulement si c'est sa réponse à la question des jambes lourdes,
         jamais par addition de plusieurs réponses. Si elle n'a pas de jambes lourdes, on parle de gonflement. */
      var lourd = lourdeur(z);
      if(grp(z) === 'jambes' && lourd > 0) out.push(fill(PH.drainage_jambes, {quand:(lourd >= 2 ? PH.quand_souvent : PH.quand_moments) + (s.cycle ? PH.quand_cycle : '')}));
      else out.push(PH.drainage_zone);
    }
  });
  if(!out.length) out.push(S.zone_pas_de_sonde || PH.vide);
  return out.join(' ');
}
function joue(){
  var H = hist(), p = prioZone(), out = [];
  if(!p) return [PH.joue_rien];
  var pp = profil(p);
  if(H.grossesse) out.push(fill(PH.joue_grossesse, {perte:H.perte ? PH.joue_perte_g : ''}));
  else if(H.perte) out.push(PH.joue_perte);
  else if(H.yoyo) out.push(PH.joue_yoyo);
  else if(H.prise) out.push(PH.joue_prise);
  if(pp.morpho && !estVisage(p)) out.push(fill(PH.joue_morpho, {de:Z[p].de}));
  if(H.menopause) out.push(PH.joue_menopause);
  var liste = [];
  if(H.endo) liste.push(PH.quoi_endo);
  if(H.sopk) liste.push(PH.quoi_sopk);
  if(H.fibro) liste.push(PH.quoi_fibro);
  if(H.thyroide) liste.push(PH.quoi_thyroide);
  if(liste.length){
    var quoi = liste.length === 1 ? liste[0] : liste.slice(0, -1).join(', ') + PH.quoi_et + liste[liste.length - 1];
    out.push(fill(PH.joue_contexte, {quoi:quoi}));
  }
  /* Diastasis et césarienne : seulement si le ventre est travaillé. */
  if(ventreTravaille()){
    if(H.diastasis) out.push(PH.joue_diastasis);
    if(H.cesarienne) out.push(PH.joue_cesar);
  }
  if(H.contraception || H.stress) out.push(PH.joue_contra);
  if(!out.length && H.poidsstable) out.push(PH.joue_stable);
  if(!out.length) out.push(PH.joue_rien);
  return out;
}
function profilLabel(p, z){
  var base = p.c.length ? p.c.map(function(x, j){ var l = PH['profil_' + x.k]; return j ? l.toLowerCase() : cap(l); }).join(' + ') : PH.profil_vide;
  return base + ((p.morpho && z && !estVisage(z)) ? ' · ' + PH.profil_morpho : '');
}
function ordreLabel(p){
  var vus = [], o = [];
  p.c.forEach(function(x){ var l = PH['ordre_' + x.k]; if(l && vus.indexOf(l) < 0){ vus.push(l); o.push(l); } });
  return o.length ? (cap(o[0]) + (o.length > 1 ? PH.ordre_puis + o.slice(1).join(PH.ordre_puis) : '')) : PH.ordre_vide;
}
function toutesTechs(){ var a = []; ordreZones().forEach(function(z){ techs(z, profil(z)).forEach(function(t){ if(a.indexOf(t) < 0) a.push(t); }); }); return a; }

var root = document.getElementById('nly-diag');
function esc(t){ return String(t == null ? '' : t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/ ([:?!€»;])/g,' $1').replace(/« /g,'« '); }
function lines(t){ return esc(t).replace(/\n/g, '<br>'); }
/* 30/09 : un mot avec un trait d'union (aimerais-tu, bas-ventre) ne se coupe jamais en fin de ligne. */
function txt(t, z){ return esc(t).replace(/\{zone\}/g, (z && Z[z]) ? Z[z].tu : 'cette zone').replace(/\{prenom\}/g, st.prenom ? ', ' + st.prenom : '').replace(/([^\s<>&;]+-[^\s<>&;]+)/g, '<span style="white-space:nowrap">$1</span>'); }
function hd(prog, showBack){
  return '<div class="hd"><div class="in">' +
    '<button class="l" data-a="back"' + (showBack ? '' : ' hidden') + '>' + esc(S.btn_retour) + '</button>' +
    '<a class="logo" href="' + D.home + '">NOLYA</a>' +
    '<a class="q r" href="' + D.home + '" data-a="quit">' + esc(S.btn_quitter) + '</a>' +
    '</div><div class="jg"' + (prog == null ? ' hidden' : '') + '><i style="width:' + (prog || 0) + '%"></i></div></div>';
}
function render(){
  try{
    var html = '';
    if(st.ecran === 'intro') html = hd(null, false) + intro();
    else if(st.ecran === 'q'){ buildFlow(); if(st.idx >= flow.length){ st.ecran = 'analyse'; return render(); } html = hd(Math.round((st.idx + 1) / (flow.length + 1) * 100), true) + question(flow[st.idx]); }
    else if(st.ecran === 'analyse') html = hd(100, false) + analyse();
    else if(st.ecran === 'res'){ buildFlow(); html = hd(null, true) + resultat(); }
    root.innerHTML = html;
    window.scrollTo(0, 0);
    bind();
    if(st.ecran === 'analyse') animAnalyse();
  } catch(err){ if(window.console) console.error('NOLYA diagnostic', err); }
}
function intro(){
  return '<div class="ec intro">' +
    '<div class="im">' + (D.intro_image ? '<img src="' + D.intro_image + '" alt="' + esc(S.intro_titre) + '">' : '') + '</div>' +
    '<div class="txt"><span class="k">' + esc(S.intro_sur) + '</span>' +
    '<h1 class="h">' + lines(S.intro_titre) + '</h1>' +
    '<p class="p">' + lines(S.intro_p1) + '</p>' +
    '<p class="p">' + lines(S.intro_p2) + '</p>' +
    '<div class="act"><label class="lab" for="prenom">' + esc(S.intro_label) + '</label><input class="champ" id="prenom" placeholder="' + esc(S.intro_placeholder) + '" value="' + esc(st.prenom) + '" autocomplete="given-name"></div>' +
    '<div class="act"><button class="btn auto" data-a="start">' + esc(S.intro_cta) + '</button></div>' +
    '<div class="meta">' + (S.intro_meta || '').split('·').map(function(x){ return '<span>' + esc(x.trim()) + '</span>'; }).join('') + '</div>' +
    '</div></div>';
}
function question(e){
  var d = Q[e.id], z = e.z, k;
  if(d.c === 'zone' && z && Z[z]){ var zs = ordreZones(); k = '02 · ' + Z[z].nom.split(/[,&]/)[0].trim() + (zs.length > 1 ? ' · ' + (zs.indexOf(z) + 1) + ' sur ' + zs.length : ''); }
  else k = CHAP[d.c] || '';
  var h = '<div class="ec"><span class="k">' + esc(k) + '</span><h1 class="h">' + txt(d.q, z) + '</h1>' + (d.s ? '<p class="s">' + txt(d.s, z) + '</p>' : '');
  var a = get(e.id, z) || [];
  if(e.id === 'zones'){
    h += '<div class="zg">';
    ZORDER.forEach(function(zz){
      h += '<button class="z' + (st.zones.indexOf(zz) >= 0 ? ' on' : '') + '" data-a="zone" data-z="' + zz + '"><div class="im">' + (Z[zz].img ? '<img src="' + Z[zz].img + '" alt="' + esc(Z[zz].nom) + '">' : '') + '</div><span class="nm">' + esc(Z[zz].nom) + '</span><i class="pk"></i></button>';
    });
    h += '</div><div class="act"><button class="btn" data-a="next"' + (st.zones.length ? '' : ' disabled') + '>' + esc(S.btn_continuer) + '</button></div><p class="hint">' + esc(S.hint_zones) + '</p>';
  } else if(e.id === 'priorite'){
    h += '<div class="opts">';
    st.zones.forEach(function(zz){ h += '<button class="op single' + (st.prio === zz ? ' on' : '') + '" data-a="prio" data-z="' + zz + '">' + esc(Z[zz].nom) + '<i></i></button>'; });
    h += '</div>';
  } else {
    var liste = listeOf(e);
    h += '<div class="opts">';
    liste.forEach(function(o, i){
      if(o.zones && o.zones.indexOf(z || '') < 0 && !(e.id === 'securite' && o.zones.some(function(x){ return st.zones.indexOf(x) >= 0; }))) return;
      h += '<button class="op' + (d.m ? '' : ' single') + (a.indexOf(i) >= 0 ? ' on' : '') + '" data-a="opt" data-i="' + i + '">' + txt(o.l, z) + '<i></i></button>';
    });
    h += '</div>';
    if(d.m) h += '<div class="act"><button class="btn" data-a="next"' + (a.length ? '' : ' disabled') + '>' + esc(S.btn_continuer) + '</button></div><p class="hint">' + esc(S.hint_multi) + '</p>';
  }
  return h + '</div>';
}
function analyse(){
  return '<div class="ec an"><span class="k">' + esc(S.an_sur) + '</span><h1 class="h">' + txt(S.an_titre) + '</h1>' +
    '<ul><li><i></i>' + esc(S.an_l1) + '</li><li><i></i>' + esc(S.an_l2) + '</li><li><i></i>' + esc(S.an_l3) + '</li></ul></div>';
}
function animAnalyse(){
  var li = root.querySelectorAll('.an li');
  li.forEach(function(el, i){ setTimeout(function(){ el.classList.add('ok'); }, 500 + i * 700); });
  setTimeout(function(){ if(st.ecran === 'analyse'){ st.ecran = 'res'; render(); } }, 500 + li.length * 700 + 700);
}
/* acc = on propose l'accompagnement. Jamais pendant une grossesse. */
function blocMail(acc){
  return '<div class="mail" id="nly-mail"><span class="k">' + esc(S.mail_sur) + '</span><p class="s">' + lines(S.mail_sous) + '</p>' +
    '<input class="champ" id="nly-email" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(S.mail_placeholder) + '">' +
    '<button class="btn o" data-a="send">' + esc(S.mail_cta) + '</button>' +
    '<small>' + esc(S.mail_note) + '</small></div>' +
    ((acc && S.acc_lien) ? '<p class="ctr" style="margin-top:26px"><a class="lien" href="' + S.acc_lien + '">' + esc(S.acc_txt) + '</a></p>' : '');
}
function blocZones(){
  var h = '<div class="bl">';
  ordreZones().forEach(function(z, i){
    var p = profil(z), det = precAffichees(z);
    h += '<div class="zn">' + (Z[z].img ? '<div class="im"><img src="' + Z[z].img + '" alt="' + esc(Z[z].nom) + '"></div>' : '') +
      '<span class="n">0' + (i + 1) + '</span><h2 class="t">' + esc(Z[z].nom) + '</h2>' +
      (det.length ? '<div class="det">' + esc(det.join(' · ')) + '</div>' : '') +
      '<div class="pf">' + esc(profilLabel(p, z)) + '</div><p>' + esc(explique(z, p)) + '</p></div>';
  });
  return h + '</div>';
}
function blocMachine(alltech, avant){
  return '<div class="tr"><span class="k">' + esc(S.mach_sur) + '</span><h2 class="h">' + lines(S.mach_titre) + '</h2>' +
    '<p class="s">' + lines(avant || (alltech ? S.mach_sous : S.mach_sous_seul)) + '</p>' +
    '<div class="im">' + (D.mach_image ? '<img src="' + D.mach_image + '" alt="' + esc(S.mach_titre || 'La Méthode NOLYA') + '">' : '') + '</div>' +
    '<div class="act"><a class="btn auto" href="' + (S.mach_lien || '#') + '">' + esc(S.mach_cta) + '</a></div>' +
    '<p class="px">' + lines(S.mach_prix).replace(/<br>(.*)$/, '<br><b>$1</b>') + '</p>' +
    (avant ? '' : '<p class="pied">' + lines(S.mach_tempo) + '</p>') +
    '<div class="rea"><span>' + esc(S.rea1) + '</span><span>' + esc(S.rea2) + '</span><span>' + esc(S.rea3) + '</span><span>' + esc(S.rea4) + '</span></div></div>';
}
/* ===================== L'ORDRE DU RÉSULTAT =====================
   Tête · précaution · zones · ce qui a joué · par où commencer · les sondes
   · GARDER MON DIAGNOSTIC · la machine · les Queues de Cerise.
   30/09 : pendant une grossesse, aucune proposition d'achat. Elle attend la fin de sa grossesse,
   son diagnostic est gardé. La machine ne revient que si un texte est rempli dans « gro_mach ». */
function resultat(){
  var V = verifs(), zs = ordreZones();
  if(grossesse()){
    return '<div class="res"><div class="bl first"><span class="k">' + esc(S.gro_sur) + '</span><h1 class="h">' + lines(S.gro_titre) + '</h1>' +
      '<p class="p">' + lines(S.gro_p) + '</p></div>' + blocZones() + blocMail(false) + (S.gro_mach ? blocMachine(false, S.gro_mach) : '') + '<div class="fin"></div></div>';
  }
  var h = '<div class="res">';
  h += '<div class="bl first"><span class="k">' + esc(S.res_sur) + '</span><h1 class="h">' + txt(S.res_titre) + '</h1><p class="s">' + lines(zs.length > 1 ? S.res_sous_multi : S.res_sous_une) + '</p></div>';
  if(V.length){
    h += '<div class="bl"><div class="note"><span class="k">' + esc(S.note_sur) + '</span><p>' + lines(V.indexOf('jambe') >= 0 ? S.note_jambe : S.note_txt) + '</p>' + (S.note_lien ? '<p style="margin-top:12px"><a class="lien" href="' + S.note_lien + '">' + esc(S.note_lien_txt) + '</a></p>' : '') + '</div></div>';
  }
  var alltech = toutesTechs();
  h += blocZones();
  h += '<div class="bl"><span class="k">' + esc(S.joue_sur) + '</span>';
  joue().forEach(function(t, i){ h += i === 0 ? '<p class="lora">' + esc(t) + '</p>' : '<p class="p">' + esc(t) + '</p>'; });
  h += '</div>';
  h += '<div class="bl"><span class="k">' + esc(S.ordre_sur) + '</span><h2 class="h">' + esc(S.ordre_titre) + '</h2><p class="s">' + lines(zs.length > 1 ? S.ordre_sous_multi : S.ordre_sous_une) + '</p><div class="ord">';
  zs.forEach(function(z, i){
    var det = precAffichees(z);
    h += '<div class="li"><span class="n">0' + (i + 1) + '</span><div class="t">' + esc(Z[z].nom) + (det.length ? ' — ' + esc(det.join(', ')) : '') + '</div><div class="x">' + esc(ordreLabel(profil(z))) + '</div></div>';
  });
  h += '</div><p class="pied">' + lines(S.ordre_pied) + '</p></div>';
  if(alltech.length){
    h += '<div class="bl"><span class="k">' + esc(S.tech_sur) + '</span><h2 class="h">' + esc(S.tech_titre) + '</h2><div class="duo">';
    alltech.forEach(function(t){
      h += '<div class="row"><div class="txt"><span class="g">' + esc(T[t].n) + '</span><span class="d">' + esc(T[t].c) + '</span></div>' +
        (T[t].i ? '<div class="so"><img src="' + T[t].i + '" alt="' + esc(T[t].n) + '"></div>' : '') + '</div>';
    });
    h += '</div></div>';
  }
  h += blocMail(true);
  h += blocMachine(alltech.length, null);
  if(besoinDrainage() && S.cer_lien){
    h += '<div class="bl prod"><span class="k">' + esc(S.cer_sur) + '</span><h2 class="h">' + lines(S.cer_titre) + '</h2>' +
      '<div class="im">' + (D.cer_image ? '<img src="' + D.cer_image + '" alt="' + esc(S.cer_titre || 'Queues de cerise NOLYA') + '">' : '') + '</div>' +
      '<div class="nom">' + esc(S.cer_nom) + '</div><div class="px">' + esc(S.cer_prix) + '</div>' +
      '<p class="s">' + lines(S.cer_txt) + '</p>' +
      '<p style="margin-top:18px"><a class="lien" href="' + S.cer_lien + '">' + esc(S.cer_cta) + '</a></p></div>';
  }
  return h + '<div class="fin"></div></div>';
}

/* ===================== L'E-MAIL =====================
   18/10 : la fiche personnelle, dans la DA des e-mails NOLYA.
   Le cadre (polices, fond, pied de page, désinscription) est dans le modèle Klaviyo.
   Tous les textes viennent des réglages de la section, rubrique « L'e-mail ». */
var C = {encre:'#1C1410', bx:'#6A0D1B', filet:'#EDE5DC', ivoire:'#F4F1ED', gris:'#8C837A', texte:'#3D3532', sable:'#EEEAE3'};
var LORA = 'font-family:Lora,Georgia,serif;', POP = 'font-family:Poppins,Arial,sans-serif;font-weight:300;';
var CAPS = 'font-family:Poppins,Arial,sans-serif;font-weight:500;font-size:9.5px;letter-spacing:1.9px;text-transform:uppercase;';
var E = {
  r: function(c, s){ return '<tr><td class="px" style="padding:0 48px;' + (s || '') + '">' + c + '</td></tr>'; },
  v: function(h){ return '<tr><td style="height:' + h + 'px;line-height:' + h + 'px;font-size:0">&nbsp;</td></tr>'; },
  k: function(t, co, s){ return '<div style="' + CAPS + (s ? 'font-size:' + s + 'px;' : '') + 'color:' + (co || C.bx) + '">' + t + '</div>'; },
  h: function(t, s, lh, pt, cl){ return '<div' + (cl ? ' class="' + cl + '"' : '') + ' style="' + LORA + 'font-size:' + s + 'px;line-height:' + lh + 'px;color:' + C.encre + ';padding-top:' + (pt || 0) + 'px">' + t + '</div>'; },
  p: function(t, s, co, pt){ return '<div style="' + POP + 'font-size:' + s + 'px;line-height:' + Math.round(s * 1.7) + 'px;color:' + (co || C.texte) + ';padding-top:' + (pt || 0) + 'px">' + t + '</div>'; },
  f: function(){ return E.r('<div style="border-top:1px solid ' + C.filet + '"></div>'); },
  a: function(u, m){ return '<a href="' + u + '" style="' + CAPS + 'color:' + C.bx + ';text-decoration:none">' + m + '</a>'; },
  b: function(u, m){ return E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0"><tr><td align="center" bgcolor="' + C.bx + '" style="background:' + C.bx + '"><a href="' + u + '" style="display:block;padding:18px 20px;' + CAPS + 'font-size:11px;letter-spacing:2.2px;color:#FFFFFF;text-decoration:none">' + m + '</a></td></tr></table>'); }
};
function lienAbsolu(u){ if(!u) return D.boutique; return /^https?:/.test(u) ? u : D.boutique + u; }
function brs(t){ return esc(t).replace(/\n/g, '<br>'); }
function plat(t){ return esc(t).replace(/\s*\n\s*/g, ' '); }
/* L'image dans la bonne taille pour l'e-mail (Shopify redimensionne à la volée). */
function taille(u, w){ if(!u) return u; return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
function mEntete(){
  return E.v(38) + '<tr><td align="center" style="padding:0 20px"><span class="logo" style="' + LORA + 'font-size:34px;letter-spacing:7px;color:' + C.bx + '">NOLYA</span></td></tr>' +
    (S.mail_entete ? '<tr><td align="center" style="padding:10px 20px 0">' + E.k(esc(S.mail_entete), C.gris) + '</td></tr>' : '') + E.v(40);
}
function mOuverture(titre, sous){
  return '<tr><td align="center" class="px" style="padding:0 48px">' + E.h(titre, 34, 40, 0, 'h1') + (sous ? E.p(sous, 13.5, C.texte, 14) : '') + '</td></tr>';
}
/* TES ZONES · TA PRIORITÉ · TECHNOLOGIES · TA ZONE (une seule zone) */
function mResume(zs, alltech){
  var L = String(S.mail_resume || '').split('·').map(function(x){ return x.trim(); });
  var cel = zs.length > 1 ? [[L[0], String(zs.length)], [L[1], esc(Z[prioZone()].nom)]] : [[L[3] || L[1], esc(Z[zs[0]].nom)]];
  if(alltech.length) cel.push([L[2], String(alltech.length)]);
  cel = cel.filter(function(c){ return c[0]; });
  if(!cel.length) return '';
  var w = Math.floor(100 / cel.length);
  return E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-top:1px solid ' + C.filet + ';border-bottom:1px solid ' + C.filet + '"><tr>' +
    cel.map(function(c, i){ return '<td width="' + w + '%" align="center" valign="top" style="padding:16px 4px;' + (i ? 'border-left:1px solid ' + C.filet : '') + '">' + E.k(esc(c[0]), C.gris, 8.5) + E.h(c[1], 17, 22, 6) + '</td>'; }).join('') +
    '</tr></table>') + E.v(44);
}
function mNote(V){
  return E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border:1px solid ' + C.bx + '"><tr><td style="padding:22px 24px;text-align:left">' +
    E.k(esc(S.note_sur)) + E.p(brs(V.indexOf('jambe') >= 0 ? S.note_jambe : S.note_txt), 13, C.texte, 10) +
    (S.note_lien ? '<div style="padding-top:12px">' + E.a(lienAbsolu(S.note_lien), esc(S.note_lien_txt)) + '</div>' : '') +
    '</td></tr></table>') + E.v(44);
}
function mZone(z, i, n){
  var p = profil(z), det = precAffichees(z), img = taille(Z[z].img, 240);
  var tag = (i === 0 && n > 1 && S.mail_prio) ? '<table role="presentation" cellpadding="0" cellspacing="0" style="margin-bottom:8px"><tr><td style="border:1px solid ' + C.bx + ';padding:4px 8px">' + E.k(esc(S.mail_prio), C.bx, 8.5) + '</td></tr></table>' : '';
  var h = E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0"><tr>' +
    (img ? '<td valign="top" width="116" style="width:116px;padding:0"><img class="vg" src="' + img + '" width="96" height="96" alt="' + esc(Z[z].nom) + '" style="display:block;width:96px;height:96px;border:0;background:' + C.sable + '"></td>' : '') +
    '<td valign="middle" style="padding:0;text-align:left">' + tag + E.h('0' + (i + 1), 13, 18).replace('color:' + C.encre, 'color:' + C.bx) + E.h(esc(Z[z].nom), 22, 27, 2) +
    (det.length ? E.p(esc(det.join(' · ')), 11.5, C.gris, 3) : '') + '</td></tr></table>');
  h += E.r(E.k(esc(profilLabel(p, z)), C.encre) + E.p(esc(explique(z, p)), 13.5, C.texte, 8), 'padding-top:18px;text-align:left');
  return h + (i < n - 1 ? E.v(30) + E.f() + E.v(30) : E.v(48));
}
function mJoue(){
  var j = joue();
  return '<tr><td bgcolor="' + C.ivoire + '" align="center" class="px" style="background:' + C.ivoire + ';padding:44px 52px">' + E.k(esc(S.joue_sur)) +
    E.h(esc(j[0]), 20, 31, 16) + (j.length > 1 ? E.p(esc(j.slice(1).join(' ')), 13, C.texte, 12) : '') + '</td></tr>' + E.v(52);
}
function mOrdre(zs){
  var rows = zs.map(function(z, i){
    var b = 'border-top:1px solid ' + C.filet + ';';
    return '<tr><td valign="top" width="40" style="padding:15px 0;' + b + LORA + 'font-size:15px;color:' + C.bx + '">0' + (i + 1) + '</td>' +
      '<td valign="top" style="padding:15px 8px 15px 0;' + b + LORA + 'font-size:16px;line-height:21px;color:' + C.encre + '">' + esc(Z[z].nom) + '</td>' +
      '<td valign="top" align="right" style="padding:16px 0;' + b + POP + 'font-size:12px;line-height:19px;color:' + C.gris + '">' + esc(ordreLabel(profil(z))) + '</td></tr>';
  }).join('');
  return E.r(E.k(esc(S.ordre_titre)), 'text-align:left') +
    E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-bottom:1px solid ' + C.filet + '">' + rows + '</table>', 'padding-top:14px') +
    (S.ordre_pied ? E.r(E.p(plat(S.ordre_pied), 12, C.gris, 14), 'text-align:left') : '') + E.v(52);
}
function mTechs(alltech){
  var h = E.r(E.k(esc(S.tech_sur)) + E.h(esc(S.tech_titre), 24, 30, 10), 'text-align:left'), rows = '';
  for(var i = 0; i < alltech.length; i += 2){
    var paire = alltech.slice(i, i + 2), b = i ? 'border-top:1px solid ' + C.filet + ';' : '';
    rows += '<tr>' + paire.map(function(t, j){
      return '<td width="' + (paire.length > 1 ? '50%' : '100%') + '" valign="top" ' + (paire.length > 1 ? '' : 'colspan="2" ') + 'style="padding:18px 16px 18px ' + (j ? 18 : 0) + 'px;' + b + (j ? 'border-left:1px solid ' + C.filet + ';' : '') + 'text-align:left">' +
        E.h(esc(T[t].n), 17, 22) + E.p(esc(T[t].c), 12, C.gris, 4) + '</td>';
    }).join('') + '</tr>';
  }
  return h + E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-top:1px solid ' + C.filet + ';border-bottom:1px solid ' + C.filet + '">' + rows + '</table>', 'padding-top:16px') + E.v(52);
}
/* « La machine… : 299,90 € » se coupe en deux : le texte, puis le prix en grand. */
function mMachine(alltech, avant){
  var m = String(S.mach_prix || '').match(/^([\s\S]*?)\s*:\s*([^:]*€)\s*$/);
  var prix = m ? E.p(brs(m[1]), 12.5, C.texte) + E.h(esc(m[2]), 30, 36, 8).replace('color:' + C.encre, 'color:' + C.bx) : E.p(brs(S.mach_prix), 12.5, C.texte);
  var bas = (avant ? [] : [esc(S.mach_tempo)]).concat([[S.rea1, S.rea2, S.rea3, S.rea4].filter(Boolean).map(function(r){ return esc(r).replace(/ /g, '&nbsp;'); }).join(' · ')]).filter(Boolean).join('<br>');
  return '<tr><td align="center" class="px" style="padding:0 48px">' + E.k(esc(S.mach_sur)) + E.h(brs(S.mach_titre), 28, 34, 12, 'h2') +
    E.p(brs(avant || (alltech ? S.mach_sous : S.mach_sous_seul)), 13, C.texte, 10) + '</td></tr>' +
    (D.mach_image ? E.r('<a href="' + lienAbsolu(S.mach_lien) + '"><img src="' + taille(D.mach_image, 1008) + '" width="504" alt="' + esc(S.mach_cta) + '" style="display:block;width:100%;max-width:504px;height:auto;border:0;background:' + C.sable + '"></a>', 'padding-top:26px') : '') +
    '<tr><td align="center" class="px" style="padding:22px 48px 22px">' + prix + '</td></tr>' +
    E.b(lienAbsolu(S.mach_lien), esc(S.mach_cta)) +
    '<tr><td align="center" class="px" style="padding:16px 48px 0">' + E.p(bas, 11, C.gris) + '</td></tr>' + E.v(52);
}
function mCerise(){
  return E.r('<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border:1px solid ' + C.filet + '"><tr><td style="padding:24px 26px;text-align:left">' +
    E.k(esc(S.cer_sur)) + E.h(esc(S.cer_nom), 19, 25, 10) + E.p(plat(S.cer_txt) + (S.cer_prix ? '<br>' + esc(S.cer_prix) : ''), 12.5, C.texte, 6) +
    '<div style="padding-top:14px">' + E.a(lienAbsolu(S.cer_lien), esc(S.cer_cta)) + '</div></td></tr></table>') + E.v(56);
}
function mSignature(acc){
  return '<tr><td align="center" class="px" style="padding:0 48px">' +
    (S.mail_question ? E.p(brs(S.mail_question), 13, C.texte) : '') +
    (S.mail_equipe ? E.h(esc(S.mail_equipe), 20, 26, 20) : '') +
    (S.mail_signature ? E.p(brs(S.mail_signature), 11, C.gris, 6) : '') +
    ((acc && S.acc_lien) ? '<div style="padding-top:20px">' + E.a(lienAbsolu(S.acc_lien), esc(S.acc_txt)) + '</div>' : '') +
    '</td></tr>' + E.v(48);
}
function construireEmail(){
  var zs = ordreZones(), V = verifs(), alltech = toutesTechs(), h = mEntete();
  var zones = zs.map(function(z, i){ return mZone(z, i, zs.length); }).join('');
  if(grossesse()){
    return h + mOuverture(brs(S.gro_titre), brs(S.gro_p)) + E.v(44) + zones + (S.gro_mach ? mMachine(false, S.gro_mach) : '') + mSignature(false);
  }
  var titre = esc(S.mail_bonjour).replace('{prenom}', st.prenom ? ',<br>' + esc(st.prenom) : '');
  h += mOuverture(titre, brs(zs.length > 1 ? S.res_sous_multi : S.res_sous_une)) + E.v(32) + mResume(zs, alltech);
  if(V.length) h += mNote(V);
  h += zones + mJoue() + mOrdre(zs);
  if(alltech.length) h += mTechs(alltech);
  h += mMachine(alltech.length, null);
  if(besoinDrainage() && S.cer_lien) h += mCerise();
  return h + mSignature(true);
}
function resumeTexte(){
  return ordreZones().map(function(z){
    var det = precisionsOf(z);
    return Z[z].nom + (det.length ? ' (' + det.join(', ') + ')' : '') + ' : ' + profilLabel(profil(z), z);
  }).join(' | ');
}
/* ===================== FIN DE L'E-MAIL ===================== */

/* ===================== L'ENVOI ===================== */
/* 18/10 : Klaviyo accepte 100 Ko par texte ; Gmail coupe un e-mail au-delà de 102 Ko. 60 000 laisse la marge du cadre. */
var LIMITE = 60000;
function couper(corps){
  if(corps.length <= LIMITE) return corps;
  var bout = corps.slice(0, LIMITE), fin = bout.lastIndexOf('</tr>');
  if(fin > 0) bout = bout.slice(0, fin + 5);
  return bout + E.r(E.p('La suite de ton diagnostic t’attend sur le site.', 13, C.gris), 'text-align:center');
}
function envoyer(email){
  var boite = root.querySelector('#nly-mail'); if(!boite) return;
  var bouton = boite.querySelector('[data-a=send]');
  if(bouton){ bouton.disabled = true; bouton.textContent = 'Envoi…'; }
  var corps = couper(construireEmail());
  var zonesTxt = ordreZones().map(function(z){ return Z[z].nom; }).join(', ');
  var prioTxt = Z[prioZone()] ? Z[prioZone()].nom : '';
  var techTxt = toutesTechs().map(function(t){ return T[t].n; }).join(', ');
  var resume = resumeTexte(), drain = besoinDrainage() ? 'oui' : 'non', verif = verifs().join(', ');
  var fiche = {
    'Diagnostic zones': zonesTxt,
    'Diagnostic zone prioritaire': prioTxt,
    'Diagnostic profil': resume,
    'Diagnostic technologies': techTxt,
    'Diagnostic drainage': drain,
    'Diagnostic verifications': verif,
    'Diagnostic date': new Date().toISOString().slice(0, 10)
  };
  var props = {
    'Prenom': st.prenom || '', 'Zones': zonesTxt, 'Zone prioritaire': prioTxt, 'Resume': resume,
    'Technologies': techTxt, 'Drainage': drain, 'Verifications': verif,
    'sujet': String(S.mail_sujet || '').replace('{prenom}', st.prenom ? ' ' + st.prenom : ''),
    'corps': corps
  };
  var co = encodeURIComponent(S.kl_company), entete = {'Content-Type': 'application/json', 'revision': '2024-10-15'};
  var attrs = {email: email, properties: fiche};
  if(st.prenom) attrs.first_name = st.prenom;
  var profilK = {data: {type: 'profile', attributes: attrs}};
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + co, {
    method: 'POST', headers: entete,
    body: JSON.stringify({data: {type: 'subscription', attributes: {profile: profilK}, relationships: {list: {data: {type: 'list', id: S.kl_list}}}}})
  }).catch(function(){});
  fetch('https://a.klaviyo.com/client/events/?company_id=' + co, {
    method: 'POST', headers: entete,
    body: JSON.stringify({data: {type: 'event', attributes: {properties: props, metric: {data: {type: 'metric', attributes: {name: S.kl_metric}}}, profile: profilK}}})
  }).then(function(r){
    if(!r.ok) return r.text().then(function(t){ throw new Error(r.status + ' ' + String(t).slice(0, 120)); });
    boite.innerHTML = '<span class="k">' + esc(S.mail_sur) + '</span><p class="ok">' + lines(S.mail_ok) + '</p>';
  }).catch(function(err){
    if(bouton){ bouton.disabled = false; bouton.textContent = S.mail_cta; }
    var e = boite.querySelector('.err');
    if(!e){ e = document.createElement('p'); e.className = 'err'; boite.appendChild(e); }
    e.textContent = S.mail_err + ' (' + (err && err.message ? err.message : 'réseau') + ')';
    if(window.console) console.error('NOLYA envoi', err, 'poids :', corps.length);
  });
}
/* ===================== FIN DE L'ENVOI ===================== */

/* Le bouton d'envoi reste gris tant que l'adresse n'est pas valable. */
function majBouton(){
  var mel = root.querySelector('#nly-email'), b = root.querySelector('[data-a=send]');
  if(!mel || !b) return;
  b.disabled = !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((mel.value || '').trim());
}
function bind(){
  root.querySelectorAll('[data-a]').forEach(function(b){ b.addEventListener('click', act); });
  var inp = root.querySelector('#prenom');
  if(inp){ inp.addEventListener('input', function(){ st.prenom = inp.value.trim().slice(0, 24); }); inp.addEventListener('keydown', function(ev){ if(ev.key === 'Enter'){ st.ecran = 'q'; st.idx = 0; render(); } }); }
  var mel = root.querySelector('#nly-email');
  if(mel){
    majBouton();
    mel.addEventListener('input', majBouton);
    mel.addEventListener('keydown', function(ev){ if(ev.key === 'Enter'){ ev.preventDefault(); tenterEnvoi(); } });
  }
}
function tenterEnvoi(){
  var mel = root.querySelector('#nly-email'); if(!mel) return;
  var v = (mel.value || '').trim();
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ mel.focus(); return; }
  envoyer(v);
}
function act(ev){
  try{
    var b = ev.currentTarget, a = b.getAttribute('data-a');
    if(a === 'quit'){ if(st.ecran !== 'intro' && !confirm(S.quit_confirm)) ev.preventDefault(); return; }
    if(a === 'send'){ tenterEnvoi(); return; }
    if(a === 'start'){ st.ecran = 'q'; st.idx = 0; render(); return; }
    if(a === 'back'){
      if(st.ecran === 'res'){ buildFlow(); st.ecran = 'q'; st.idx = Math.max(0, flow.length - 1); }
      else if(st.idx === 0){ st.ecran = 'intro'; }
      else st.idx--;
      render(); return;
    }
    if(a === 'next'){ st.idx++; render(); return; }
    var e = flow[st.idx]; if(!e) return;
    var d = Q[e.id], liste = listeOf(e);
    if(a === 'zone'){
      var z = b.getAttribute('data-z'), i = st.zones.indexOf(z);
      if(i >= 0){ st.zones.splice(i, 1); if(st.prio === z) st.prio = null; } else st.zones.push(z);
      st.zones = ZORDER.filter(function(x){ return st.zones.indexOf(x) >= 0; });
      b.classList.toggle('on'); var n = root.querySelector('[data-a=next]'); if(n) n.disabled = !st.zones.length;
      return;
    }
    if(a === 'prio'){ st.prio = b.getAttribute('data-z'); b.classList.add('on'); setTimeout(function(){ st.idx++; render(); }, 340); return; }
    if(a === 'opt'){
      var i2 = parseInt(b.getAttribute('data-i'), 10), k = key(e), cur = st.ans[k] || [];
      if(d.m){
        if(liste[i2].x) cur = cur.indexOf(i2) >= 0 ? [] : [i2];
        else { cur = cur.filter(function(j){ return !liste[j].x; }); var p2 = cur.indexOf(i2); if(p2 >= 0) cur.splice(p2, 1); else cur.push(i2); }
        st.ans[k] = cur;
        root.querySelectorAll('.op').forEach(function(el){ el.classList.toggle('on', cur.indexOf(parseInt(el.getAttribute('data-i'), 10)) >= 0); });
        var n2 = root.querySelector('[data-a=next]'); if(n2) n2.disabled = !cur.length;
      } else {
        st.ans[k] = [i2];
        root.querySelectorAll('.op').forEach(function(el){ el.classList.remove('on'); }); b.classList.add('on');
        setTimeout(function(){ st.idx++; render(); }, 340);
      }
    }
  } catch(err){ if(window.console) console.error('NOLYA diagnostic', err); }
}
render();
})();
